import { ParticipantQualifyComponent } from './participant/participant_qualify/participant_qualify.component';
import { ParticipantDisqualifyComponent } from './participant/participant_disqualify/participant_disqualify.component';
import { ParticipantDisqualifyDemographicComponent } from './participant/participant-disqualify-demographic/participant-disqualify-demographic.component';
import { ParticipantReferComponent } from './participant/participant_refer/participant_refer.component';
import { ParticipantHomeComponent } from './participant/participant_home/participant_home.component';
import { ParticipantStudyDetailComponent } from './shared/participant-study-detail/participant_study_detail.component';
import { ParticipantStudyDemographicsComponent } from './participant/participant_study_demographics/participant_study_demographics.component';
import { ParticipantBonusComponent } from './participant/participant-bonus/participant-bonus.component';
import { ParticipantStudyNotFoundComponent } from './participant/participant-study-not-found/participant-study-not-found.component';
import { ParticipantLayoutComponent } from './_layout/participant-layout/participant-layout.component';
import { AdminLayoutComponent } from './_layout/admin-layout/admin-layout.component';
import { nonTenantHomeMatchGuard, tenantHomeMatchGuard } from 'src/services/tenant-home.guard';
import { StudyListResolverService } from 'src/services/study-list-resolver.service';
import { FirstNavigationGuard } from 'src/services/first-navigation.guard';
import { CanDeactivateGuard } from 'src/services/can-deactivate.guard';
import { AdminHomeComponent } from './admin/Study/admin_home/admin_home.component';
import { AdminStudyDetailComponent } from './admin/Study/admin_study_detail/admin_study_detail.component';
import { AdminPrescreenerComponent } from './admin/pre-screening-questions/admin_prescreener/admin_prescreener.component';
import { AdminPreScreenerListComponent } from './admin/pre-screening-questions/admin_prescreener_list.component';
import { QuestionLibraryComponent } from './admin/question-library/question-library.component';
import { CreatePrescreeningQuestionComponent } from './admin/create-prescreening-question/create-prescreening-question.component';
import { AdminSiteConfigurationComponent } from './admin/admin-site-configuration/admin-site-configuration.component';
import { AdminParticipantAnswersComponent } from './admin/admin-participant-answers/admin-participant-answers.component';
import { AdminParticipantListComponent } from './admin/admin-participant-list/admin-participant-list.component';
import { AdminNotFoundComponent } from './admin/admin-not-found/admin-not-found.component';
import { GroupMemberComponent } from './admin/group-member/group-member.component';
import { GroupMemberDetailsComponent } from './admin/group-member-details/group-member-details.component';
import { RestrictionComponent } from './admin/restriction/restriction.component';
import { AddRestrictionComponent } from './admin/add-restriction/add-restriction.component';
import { ParticipantLayoutComponent as LsrParticipantLayoutComponent } from './LSR/_layout/participant-layout/participant-layout.component';
import { ParticipantHomeComponent as LsrParticipantHomeComponent } from './LSR/participant/participant_home/participant_home.component';
import { ParticipantDisqualifyComponent as LsrParticipantDisqualifyComponent } from './LSR/participant/participant_disqualify/participant_disqualify.component';
import { ParticipantQualifyComponent as LsrParticipantQualifyComponent } from './LSR/participant/participant_qualify/participant_qualify.component';
import { ParticipantDisqualifyDemographicComponent as LsrParticipantDisqualifyDemographicComponent } from './LSR/participant/participant-disqualify-demographic/participant-disqualify-demographic.component';
import { ParticipantStudyNotFoundComponent as LsrParticipantStudyNotFoundComponent } from './LSR/participant/participant-study-not-found/participant-study-not-found.component';
import { ParticipantStudyDemographicsComponent as LsrParticipantStudyDemographicsComponent } from './LSR/participant/participant_study_demographics/participant_study_demographics.component';
import { ParticipantReferComponent as LsrParticipantReferComponent } from './LSR/participant/participant_refer/participant_refer.component';
import { ParticipantBonusComponent as LsrParticipantBonusComponent } from './LSR/participant/participant-bonus/participant-bonus.component';
import { LsrCroComponent } from './LSR/participant/lsr_cro/lsr_cro.component';
import { LsrContactComponent } from './LSR/participant/lsr_contact/lsr_contact.component';
import { LsrPrivacyComponent } from './LSR/participant/lsr_privacy/lsr_privacy.component';
import { PrivacyPolicyFormComponent } from './LSR/participant/privacy-policy-form/privacy-policy-form.component';
import { Routes } from '@angular/router';
import { UnauthorizedUser } from './unauthorized-user/unauthorized-user';

export const routes: Routes = [
  {
    path: 'unauthorized-user', component: UnauthorizedUser
  },
  {
    path: '', component: LsrParticipantLayoutComponent, canMatch: [tenantHomeMatchGuard],
    children: [
      {
        path: '', component: LsrParticipantHomeComponent
      },
      {
        path: 'ParticipantStudyDetail/:studyid', component: ParticipantStudyDetailComponent,
        children: [
          {
            path: '', component: LsrParticipantDisqualifyComponent
          },
          {
            path: 'ParticipantDisqualify', component: LsrParticipantDisqualifyComponent
          },
          {
            path: 'ParticipantQualify', component: LsrParticipantQualifyComponent
          },
          {
            path: 'ParticipantDisqualifyDemographic', component: LsrParticipantDisqualifyDemographicComponent
          }
        ]
      },
      {
        path: 'ParticipantStudyDetail/:studyid/study-not-found', component: LsrParticipantStudyNotFoundComponent
      },
      {
        path: 'ParticipantStudyDemographics', component: LsrParticipantStudyDemographicsComponent
      },
      {
        path: 'participantrefer', component: LsrParticipantReferComponent
      },
      {
        path: 'ParticipantBonus', component: LsrParticipantBonusComponent
      },
      {
        path: 'lsr-cro', component: LsrCroComponent
      },
      {
        path: 'contactus', component: LsrContactComponent
      },
      {
          path: 'privacypolicy', component: LsrPrivacyComponent
      },
      {
         path: 'privacypolicyform', component: PrivacyPolicyFormComponent 
      }
    ]
  },
  {
    path: '', component: ParticipantLayoutComponent, canMatch: [nonTenantHomeMatchGuard],
    children: [
      {
        path: '', component: ParticipantHomeComponent,
      },
      {
        path: 'ParticipantStudyDetail/:studyid', component: ParticipantStudyDetailComponent,
        children: [
          {
            path: '', component: ParticipantDisqualifyComponent
          },
          {
            path: 'ParticipantDisqualify', component: ParticipantDisqualifyComponent
          },
          {
            path: 'ParticipantQualify', component: ParticipantQualifyComponent
          },
          {
            path: 'ParticipantDisqualifyDemographic', component: ParticipantDisqualifyDemographicComponent
          }
        ]
      },
      {
        path: 'ParticipantStudyDetail/:studyid/study-not-found', component: ParticipantStudyNotFoundComponent
      },
      {
        path: 'ParticipantStudyDemographics', component: ParticipantStudyDemographicsComponent
      },
      {
        path: 'participantrefer', component: ParticipantReferComponent
      },
      // {
      //   path: 'contactus', component: ParticipantContactusComponent
      // },
      {
        path: 'ParticipantBonus', component: ParticipantBonusComponent
      } 
    ]
  },
  {
    path: 'adminhome',component: AdminLayoutComponent, resolve: { studyList: StudyListResolverService }, 
    children: [
      {
        path: '', component: AdminHomeComponent, resolve: { studyList: StudyListResolverService }, canActivate: [FirstNavigationGuard]
      },
      {
        path: 'studydetail/:id', component: AdminStudyDetailComponent, canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'studydetail', component: AdminStudyDetailComponent, canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'addnewpre/:studyId', component: AdminPrescreenerComponent
      },
      {
        path: 'addnewpre/:studyId/:questionId', component: AdminPrescreenerComponent
      },
      {
        path: 'Prescreener', component: AdminPreScreenerListComponent
      },
      {
        path: 'QuestionLibrary', component: QuestionLibraryComponent, canActivate: [FirstNavigationGuard]
      },
      {
        path: 'addnewquestions/:studyId', component: CreatePrescreeningQuestionComponent
      },
      {
        path: 'addnewquestions', component: CreatePrescreeningQuestionComponent
      },
      {
        path: 'addnewpre', component: AdminPrescreenerComponent
      },
      {
        path: 'Participants', component: AdminParticipantListComponent
      },
      {
        path: 'SiteConfiguration', component: AdminSiteConfigurationComponent, canActivate: [FirstNavigationGuard]
      },
      {
        path: 'admin-participant-answers/:pid/:sid', component: AdminParticipantAnswersComponent
      },
      {
        path: 'notfound', component: AdminNotFoundComponent
      },
      {
        path: 'GroupMember', component: GroupMemberComponent
      },
      {
        path: 'group-member-details/:groupMemberId', component: GroupMemberDetailsComponent
      },
      {
        path: 'Restriction', component: RestrictionComponent
      },
      {
        path: 'AddRestriction/:restrictApplicantId', component: AddRestrictionComponent
      },
      {
        path: '**', component: AdminNotFoundComponent
      }
    ]
  },
];
